// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  margin: 0;
}
.leaflet-container {
  height: 200px;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: 5px;
  padding: 5px;
}

#map {
  height: 470px;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: 5px;
  margin-right: 5px;
  position: relative;
}

.button {
  background-color: yellowgreen;
  color: white;
  border: none;
  text-align: center;
  padding: 15px 32px;
  cursor: pointer;
  font-size: large;
}

:root {
  --map-tiles-filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg)
    saturate(0.3) brightness(0.7);
}

@media (prefers-color-scheme: dark) {
  .map-tiles {
    filter: var(--map-tiles-filter, none);
  }
}

.legend {
  width: 180px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/leaflet.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;iCAC+B;AACjC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,YAAY;AACd","sourcesContent":["html,\nbody {\n  height: 100%;\n  margin: 0;\n}\n.leaflet-container {\n  height: 200px;\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  margin: 5px;\n  padding: 5px;\n}\n\n#map {\n  height: 470px;\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  margin: 5px;\n  margin-right: 5px;\n  position: relative;\n}\n\n.button {\n  background-color: yellowgreen;\n  color: white;\n  border: none;\n  text-align: center;\n  padding: 15px 32px;\n  cursor: pointer;\n  font-size: large;\n}\n\n:root {\n  --map-tiles-filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg)\n    saturate(0.3) brightness(0.7);\n}\n\n@media (prefers-color-scheme: dark) {\n  .map-tiles {\n    filter: var(--map-tiles-filter, none);\n  }\n}\n\n.legend {\n  width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
